import parameterCaptchaMiddleware from './parameter-captcha.middleware'
import queryParamsMiddleware from './query-params.middleware'

export default [parameterCaptchaMiddleware, queryParamsMiddleware]
